import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'rsuite';

// styles
import styles from './alertMessage.module.less';

const AlertMessage = ({
  icon = '',
  title = '',
  description = '',
  type = '',
  isHeaderMessage = false,
  isRounded,
  ...rest
}) => {
  const classNames = `
    ${styles.alertMessageContainer}
    ${styles[type]}
    ${isHeaderMessage ? styles.alertMessageHeader : ''}
    ${isRounded ? styles.vpAlertMessageRounded : ''}
  `;

  return (
    <section className={classNames} {...rest}>
      {icon && <Icon size="lg" icon={icon} />}
      <div>
        {title && <div className={styles.alertMesssageTitle}>{title}</div>}
        {description && <div>{description}</div>}
      </div>
    </section>
  )
};

AlertMessage.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.string,
  isHeaderMessage: PropTypes.bool,
  isRounded: PropTypes.bool,
};

export default AlertMessage;



// WEBPACK FOOTER //
// ./src/components/AlertMessage/AlertMessage.jsx